import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 150px;
  width: 95%;
  margin-left: 2%;
  background-color: #fff;
  border-radius: 10px;

  margin-top: 0.6rem;
  user-select: none;
  cursor: pointer;
  :hover {
    background: rgba(207, 248, 231, 0.6);
  }
`;

export const IterableTitleSlot = styled.div`
  display: flex;
  margin-top: 1rem;
  margin-left: 1.4rem;
  align-items: center;
`;

export const IterableTitle = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 700;
  font-size: 1.22rem;
  line-height: 1.5rem;
`;

export const Warning = styled.span`
  margin-left: 0.6rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  color: ${({ delta }) =>
    delta < -6 ? "#1C7A1A" : delta >= -6 && delta <= 6 ? "#807228" : "#D93333"};
`;

export const IterableSubTitle = styled.span`
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  margin-top: 0.4rem;
  margin-left: 1.4rem;
  color: #717171;
`;
export const GreyBar = styled.div`
  height: 1rem;
  align-self: center;
  width: 98%;
  border-bottom: 0.07rem solid #ccc;
`;
export const IterableBottom = styled.div`
  display: flex;
  height: 4rem;
  width: 100%;
`;

export const BottomTitles = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.76rem;
  line-height: 0.95rem;
  color: #7e858f;

  margin-top: 0.4rem;
`;

export const BottomText = styled.div`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #232323;
  margin: 0.4rem;
  padding: 0 0.4rem;

  display: flex;
  align-items: center;
  justify-content: space-around;

  svg {
    fill: #40e5a0;
    width: 1.07rem;
    height: 1.07rem;
    margin-right: 0.4rem;
  }
  path {
    stroke: #40e5a0;
  }

  span {
    font-family: "Sora";
    font-style: normal;
    font-weight: 800;
    font-size: 0.8rem;
    line-height: 1rem;
    text-align: center;
    color: #1ba3f0;
    position: relative;
    margin-left: 0.4rem;
  }
`;
export const IterableData = styled.div`
  height: 100%;
  width: ${({ width }) => width};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  border-right: 0.07rem solid #ccc;
`;

export const LastData = styled.div`
  height: 100%;
  width: ${({ width }) => width};
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  position: relative;
`;

export const EmptyCounter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  margin-right: 1.5rem;
  margin-left: 0.8rem;
`;
